import { styled } from '@mui/material';

import { Button } from '~/components/ui/button';
import { Text } from '~/components/ui/text';
import { DESKTOP_MIN_WIDTH } from '~/constants/common';
import CreateQrPoster from '~/pages/HomePage/components/create-qr-poster/CreateQrPoster';
import { COLORS } from '~/styles/colors';

interface StyledPlanProps {
  $isYear?: boolean;
}

interface StyledImageProps {
  isRight?: boolean;
}

export const StyledWrapper = styled('main')(() => ({
  backgroundColor: COLORS.lightGray,
  position: 'relative',
  zIndex: 1,
  overflow: 'hidden',
}));

export const StyledContainer = styled('div')(({ theme }) => ({
  backgroundColor: COLORS.lightGray,
  paddingBottom: '100px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    paddingBottom: '20px',
  },
}));

export const StyledTitle = styled(Text)(({ theme }) => ({
  paddingTop: '50px',
  textAlign: 'center',
  marginBottom: '8px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    paddingTop: '20px',
  },
}));

export const StyledSubtitle = styled(Text)(({ theme }) => ({
  marginBottom: '57px',
  textAlign: 'center',
  color: COLORS.grey400,
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    marginBottom: '32px',
  },
}));

export const StyledPlansContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '44px',
  maxWidth: '975px',
  margin: '0 auto',
  width: '100%',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    flexDirection: 'column',
    gap: '12px',
  },
}));

export const StyledPlan = styled('div')<StyledPlanProps>(({ theme, $isYear }) => ({
  padding: $isYear ? '70px 46px' : '40px',
  flex: 1,
  borderRadius: '20px',
  boxShadow: `0 0 20px 0 rgba(0, 0, 0, 0.05)`,
  position: 'relative',
  border: $isYear ? `1px solid ${COLORS.primary}` : undefined,
  backgroundColor: COLORS.lightGray,
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    width: '100%',
    padding: '40px',
  },
}));

export const StyledPlanTitle = styled(Text)<StyledPlanProps>(({ theme, $isYear }) => ({
  padding: '8px 12px',
  backgroundColor: $isYear ? COLORS.lightGreenBg : COLORS.lightGray,
  borderRadius: '4px',
  width: 'fit-content',
  textTransform: 'uppercase',
  color: $isYear ? COLORS.green2 : COLORS.grey400,
  textAlign: 'center',
  marginInline: 'auto',
  marginBottom: '16px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {},
}));

export const StyledPlanBuyButton = styled(Button)(({ theme }) => ({
  padding: '12px 40px !important',
  marginTop: '30px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    padding: '8px 40px !important',
    marginTop: '44px',
  },
}));

export const StyledBestChoice = styled(Text)(() => ({
  top: 0,
  position: 'absolute',
  padding: '4px 10px',
  borderRadius: '4px',
  backgroundColor: COLORS.textMain,
  color: COLORS.white,
  transform: 'translate(-50%, -50%)',
  whiteSpace: 'nowrap',
  left: '50%',
}));

export const StyledFAQTitle = styled(Text)(({ theme }) => ({
  marginTop: '98px',
  textAlign: 'center',
  marginBottom: '57px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    marginTop: '60px',
    marginBottom: '40px',
  },
}));

export const StyledCreateQRPoster = styled(CreateQrPoster)(({ theme }) => ({
  marginTop: '120px',
  marginBottom: 0,
  gap: '37px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    marginTop: '20px',
  },
}));

export const StyledLoaderContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
}));

export const StyledImage = styled('img')<StyledImageProps>(({ theme, isRight }) => {
  if (isRight) {
    return {
      position: 'absolute',
      right: '-90px',
      transform: 'rotate(112deg)',
      top: '-144px',
      zIndex: 0,
      [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
        maxWidth: '50%',
      },
    };
  }

  return {
    position: 'absolute',
    top: '202px',
    zIndex: 0,
    left: 0,
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      maxWidth: '50%',
    },
  };
});
